import React from 'react';

import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import '../Landing.css';

import { Grid, List, ListItem, ListItemText } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import headersSection from '../headersStyle';
import testimonialsSection from '../testimonialsStyle';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    boxShadow: 'none',
  },
  panel: {
    border: '1px solid #162f65',
    borderTop: 'none',
    color: '#121b35',
    position: 'relative',
  },
  closedPanel: {
    expanded: false,
  },
  firstPanel: {
    borderTop: '1px solid #162f65',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  summary: {
    paddingRight: '0',
    // position: "relative"
  },
  icon: {
    position: 'absolute',
    top: '50%',
    transform: 'translate(50%,-50%) rotate(180deg)',
    right: 0,
    '&:focus': {
      outline: 'none',
    },
  },
  expandButton: {
    border: '1px solid #162f65',
    color: '#162f65',
    borderRadius: '50%',
    position: 'absolute',
    backgroundColor: '#fff',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  centered: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
}));

const ServiceList = (props) => {
  const { classes } = props;
  const expClasses = useStyles();

  return (
    <div className={classes.services} id="serviceList">
      <div className={classes.container} style={{ paddingTop: '50px' }}>
        <Grid container justify="center">
          <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={classes.title}>
              Перелік послуг, які можна отримати через програмний комплекс «Інтегрована інформаційна система «Соціальна
              громада»
            </h2>
          </Grid>
          <Grid item xs={12} sm={12} md={10}>
            <div className={expClasses.root}>
              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>1</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={`${expClasses.panel} ${expClasses.firstPanel}`}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>Допомога сім’ям з дітьми</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="1.1.	Допомога у зв'язку з вагітності та пологами жінками, звільненим у зв‘язку з ліквідацією підприємства" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.2.	Допомога у зв'язку з вагітністю та пологами жінкам, зареєстрованим в центрі зайнятості як безробітні" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.3.	Допомога у зв'язку з вагітністю та пологами аспіранткам, докторанткам, студенткам" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.4.	Допомога у зв'язку з вагітністю та пологами непрацюючим жінкам" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.5.	Допомога у зв'язку з вагітністю та пологами, жінкам,зареєстрованим як СПД" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.6.	Допомога при народженні дитини" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.7.	Допомога на дітей, над якими встановлено опіку чи піклуванням" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.8.	Допомога на дітей одиноким матерям" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.9.	Допомога при усиновлені дитини" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="1.10.	Допомога особі, яка доглядає за хворою дитиною" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                    {/* <IconButton className={expClasses.icon} onClick={(e, expanded) => {
                                            console.log(e.currentTarget.parentElement);
                                            onChange(e, expanded);
                                        }}>
                                            <ExpandMoreIcon
                                                className={expClasses.expandButton}
                                            />
                                        </IconButton> */}
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* <ExpansionPanel>
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={expClasses.heading}>1. Допомога сім’ям з дітьми</Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <ListItemText primary="1.1.	Допомога у зв'язку з вагітності та пологами жінками, звільненим у зв‘язку з ліквідацією підприємства" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.2.	Допомога у зв'язку з вагітністю та пологами жінкам, зареєстрованим в центрі зайнятості як безробітні" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.3.	Допомога у зв'язку з вагітністю та пологами аспіранткам, докторанткам, студенткам" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.4.	Допомога у зв'язку з вагітністю та пологами непрацюючим жінкам" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.5.	Допомога у зв'язку з вагітністю та пологами, жінкам,зареєстрованим як СПД" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.6.	Допомога при народженні дитини" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.7.	Допомога на дітей, над якими встановлено опіку чи піклуванням" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.8.	Допомога на дітей одиноким матерям" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.9.	Допомога при усиновлені дитини" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="1.10.	Допомога особі, яка доглядає за хворою дитиною" />
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </ExpansionPanelDetails>
                            </ExpansionPanel> */}

              {/* point 2 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>2</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>Допомога малозабезпеченим сім`ям</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="2.1.	Державна соціальна допомога малозабезпеченим сім'ям" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 3 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>3</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога особам з інвалідністю та дітям з інвалідністю
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="3.1.	Державна соціальна допомога особам з інвалідністю та дітям з інвалідністю" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 4 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>4</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога особам, які не мають право на пенсію та особам з інвалідністю
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="4.1.	Допомога особам з інвалідністю І групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.2.	Допомога жінкам, яким присвоєно звання “Мати-героїня”" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.3.	Допомога особам з інвалідністю ІІ групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.4.	Допомога особам з інвалідністю ІІІ групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.5.	Допомога священнослужителям, церковнослужителям" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.6.	Допомога особам, які досягли віку, що дає право на призначення допомоги" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.7.	Допомога на догляд малозабезпеченим особам з інвалідністю підгрупи А та Б І групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.8.	Допомога на догляд одиноким малозабезпеченим особам, які за висновком ЛКК закладу охорони здоров'я потребують постійного стороннього догляду (крім осіб з інвалідністю І групи)" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.9.	Допомога дитині померлого годувальника" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="4.10. Допомога на догляд одиноким особам, які досягли 80-ти річного віку та за висновком ЛКК закладу охорони здоров’я потребують постійного стороннього догляду (крім осіб з інвалідністю внаслідок війни)" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 5 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>5</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Компенсація вартості продуктів харчування громадян, які постраждали внаслідок Чорнобильської
                        катастрофи
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="5.1.	Компенсація 50 процентів вартості продуктів харчування за медичними (фізіологічними) нормами, встановленими Міністерством охорони здоров'я України, громадянам, які віднесені до 1 категорії" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="5.2.	Компенсація 25 процентів вартості продуктів харчування за медичними (фізіологічними) нормами, встановленими Міністерством охорони здоров'я України, громадянам, які віднесені до 2 категорії" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="5.3.	Грошова компенсація на дітей віком від 6 до 10 років за дні, в які не відвідували навчальний заклад" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="5.4.	Грошова компенсація на дітей віком від 11 до 14 років за дні, в які не відвідували навчальний заклад" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="5.5.	Грошова компенсація на дітей віком від 15 до 18 років за дні, в які не відвідували навчальний заклад" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 6 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>6</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога дітям, батьки яких ухиляються від сплати аліментів, не мають можливості утримувати
                        дитину або місце проживання їх невідоме
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="6.1.	Тимчасова державна допомога, коли місце проживання матері (батька) невідоме" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="6.2.	Тимчасова державна допомога, коли мати (батько) ухиляються від сплати аліментів" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="6.3.	Тимчасова державна допомога, коли мати (батько) не мають можливості утримувати дитину" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 7 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>7</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога на дітей-сиріт та дітей, позбавлених батьківського піклування, грошового забезпечення
                        батькам-вихователям і прийомним батькам за надання соціальних послуг у дитячих будинках
                        сімейного типу та прийомних сім’ях за принципом “гроші ходять за дитиною”, оплати послуг із
                        здійснення патронату над дитиною та виплати соціальної допомоги на утримання дитини в сім’ї
                        патронатного вихователя, підтримки малих групових будинків
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="7.1.	Грошове забезпечення прийомним батькам та соціальна допомога дітям-сиротам" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="7.2.	Грошове забезпечення батькам - вихователям та соціальна допомога дітям-сиротам" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 8 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>8</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога особі, яка проживає разом з особою з інвалідністю І чи ІІ групи внаслідок психічного
                        розладу, який за висновком ЛКМЗ потребує постійного стороннього догляду, на догляд за ним
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="8.1.	Щомісячна грошова допомога особі, яка проживає разом з особою з інвалідністю І чи ІІ групи внаслідок психічного розладу, який за висновком ЛКМЗ потребує постійного стороннього догляду, на догляд за ним" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 9 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>9</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Компенсації фізичним особам, які надають соціальні послуги
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="9.1.	Компенсація фізичним особам, які надають соціальні послуги особам з інвалідністю І групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.2.	Компенсація фізичним особам, які надають соціальні послуги громадянам похилого віку, які за висновком ЛКК потребують постійного стороннього догляду і не здатні до самообслуговування, особам з інвалідністю II групи та дітям з інвалідністю" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.3.	Компенсація фізичним особам, які надають соціальні послуги особам з інвалідністю III групи та хворим, які за висновком ЛКК потребують постійного стороннього догляду і не здатні до самообслуговування" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.4. Компенсація фізичним особам, які надають соціальні послуги з догляду на непрофесійній основі особам з інвалідністю І групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.5. Компенсація фізичним особам, які надають соціальні послуги з догляду на непрофесійній основі дітям з інвалідністю" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.6. Компенсація фізичним особам, які надають соціальні послуги з догляду на непрофесійній основі громадянам похилого віку з когнітивними порушеннями" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.7. Компенсація фізичним особам, які надають соціальні послуги з догляду на непрофесійній основі невиліковно хворим" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="9.8. Компенсація фізичним особам, які надають соціальні послуги з догляду на непрофесійній основі дітям, яким не встановлено інвалідність" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 10 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>10</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Винагорода жінці, якій присвоєно почесне звання України "Мати-героїня"
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary='10.1.	Одноразова винагорода жінці, якій присвоєно почесне звання України "Мати-героїня"' />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 11 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>11</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомоги особам, які постраждали від торгівлі людьми
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="11.1.	Одноразова матеріальна допомога особі, яка постраждала від торгівлі людьми" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 12 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>12</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>Допомога на поховання</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="12.1.	Допомога на поховання" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 13 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>13</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомоги непрацюючій особі, яка досягла загального пенсійного віку, але не набула права на
                        пенсійну виплату
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="13.1.	Тимчасова державна соціальна допомога непрацюючій особі, яка досягла загального пенсійного віку, але не набула права на пенсійну виплату" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 14 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>14</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога на утримання дитини в сiм'ї патронатного вихователя
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="14.1.	Грошове забезпечення та соціальна допомога на утримання дитини в сiм'ї патронатного вихователя" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 15 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>15</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога військовослужбовцям, звільненим з строкової служби
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="15.1.	Одноразова матеріальна допомога військовослужбовцям, звільненим з строкової служби" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 16 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>16</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога в разi загибелi (смерті) або iнвалiдності волонтера
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="16.1.	Одноразова грошова допомога в разi загибелi (смерті) волонтера" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="16.2.	Одноразова грошова допомога в разi iнвалiдності волонтера" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 17 */}
              {/* <div className={expClasses.root}> */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>17</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога внутрішньо переміщеним особам для покриття витрат на проживання
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="17.1.	Допомога внутрішньо переміщеним особам для покриття витрат на проживання" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 18 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>18</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Допомога на дітей, які виховуються у багатодітних сім'ях
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="18.1.	Допомога на дітей, які виховуються у багатодітних сім'ях" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 19 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>19</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Грошова компенсація замість санаторно курортного лікування
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="19.1.	Компенсація замiсть санаторно-курортної путiвки особі з iнвалідністю 1 групи (стаття 6 (2))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.2.	Компенсація замiсть санаторно-курортної путiвки особі з iнвалідністю 2 групи (стаття 6 (2))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.3.	Компенсація замiсть санаторно-курортної путiвки особі з iнвалідністю 3 групи (стаття 6 (2))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.4.	Компенсація за путiвки особам з iнвалідністю ВВВ 1 групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.5.	Компенсація за путiвки особам з інвалідністю ВВВ 2 групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.6.	Компенсація за путiвки особам з iнвалідністю ВВВ 3 групи" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.7.	Компенсація за санаторно-курортне лікування потерпілим внаслідок ЧК 1 категорії" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.8.	Компенсація за санаторно-курортне лікування дітям, потерпілим внаслідок ЧК" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.9.	Компенсація за путiвку та самостiйне лiкування особам з інвалідністю 1 групи (стаття 2)" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.10.	Компенсація за путiвку та самостiйне лiкування особам з iнвалідністю 2 групи (стаття 2)" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="19.11.	Компенсація за путiвку та самостiйне лiкування особам з iнвалідністю 3 групи (стаття 2)" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 20 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>20</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Компенсація вартості самостійного санаторно курортного лікування
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="20.1.	Компенсація самостійного санаторно-курортного  лікування УБД (стаття 1)" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.2.	Компенсація самостійного санаторно-курортного лікування учасникам війни (стаття 1)" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.3.	Компенсація самостійного санаторно-курортного лікування особам, на яких поширюється чинна стаття 15" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.4.	Компенсація самостійного санаторно-курортного лікування колишнім неповнолітнім в'язням (стаття 6 (1))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.5.	Компенсація самостійного санаторно-курортного лікування колишнім в'язням (стаття 6 (3))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.6.	Компенсація самостійного санаторно-курортного лікування дружинам жертв нацистських переслідувань (стаття 6 (4))" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="20.7.	Компенсація самостійного санаторно-курортного лікування ветеранам праці (стаття 7)" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 21 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>21</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Пільги на придбання твердого та рідкого пічного палива і скрапленого газу
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="21.1.	Пільга на придбання твердого палива" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="21.2.	Пільга на придбання скрапленого газу" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>

              {/* point 22 */}

              <Grid container>
                <Grid item xs={1}>
                  <div className={expClasses.centered}>22</div>
                </Grid>
                <Grid item xs={11}>
                  <ExpansionPanel square className={expClasses.panel}>
                    <ExpansionPanelSummary
                      className={expClasses.summary}
                      expandIcon={<ExpandMoreIcon className={expClasses.expandButton} />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography className={expClasses.heading}>
                        Субсидія для відшкодування витрат на оплату житлово-комунальних послуг, придбання скрапленого
                        газу, твердого та рідкого пічного побутового палива
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div>
                        <List>
                          <ListItem>
                            <ListItemText primary="22.1.	ЖКП" />
                          </ListItem>
                          <ListItem>
                            <ListItemText primary="22.2.	СГТП" />
                          </ListItem>
                        </List>
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(headersSection)(ServiceList);
